import { defineMessages } from "react-intl";

const messages = defineMessages({
  infoHeader: {
    id: "fileStorage.components.infoHeader",
    defaultMessage:
      "The following steps are required in order for a successful application:",
  },
  infoBucket: {
    id: "fileStorage.components.infoBucket",
    defaultMessage: "Create a bucket to store files on GCS.",
  },
  infoTopic: {
    id: "fileStorage.components.infoTopic",
    defaultMessage:
      "Create PubSub topic name to associate bucket and files. (If required)",
  },
  infoLegit: {
    id: "fileStorage.components.infoLegit",
    defaultMessage:
      "Create and assign appropriate legit permissions that are required for read (If required) and write access.",
  },
});
export default messages;
